import * as C from "./styles";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import PrimaryButton from "../../../../components/Button";
import { StateGlobal } from "../../../../context/GlobalContext";
import background_logo from "../../../../assets/images/logo-centro-medico.png";
import api from "../../../../services/api";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

export default function DoctorLogin() {
  const MySwal = withReactContent(Swal);

  const { data_doctor, setData_doctor } = StateGlobal();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [disabled, setDisabled] = useState(true);

  async function handleSubmit() {
    setDisabled(true);
    try {
      const res = await api.post("/api/doctor/token/send", {
        email: data_doctor?.email,
        password: data_doctor?.password,
      });
      if (res.data.error === "false") {
        MySwal.fire({
          icon: "success",
          title: `${res.data.message}`,
          showConfirmButton: false,
          timer: 2500,
        });

        setTimeout(() => {
          navigate("/doutor/token");
        }, [2500]);
      } else {
        MySwal.fire({
          icon: "error",
          title: `${res.data.message}`,
          showConfirmButton: false,
          timer: 3000,
        });
      }

      setDisabled(false);
    } catch (err) {
      if (err.response.status === 422) {
        MySwal.fire({
          icon: "error",
          title: "E-mail inválido",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        MySwal.fire({
          icon: "error",
          title: "Erro! tente novamente",
          showConfirmButton: false,
          timer: 3000,
        });
      }
      setDisabled(false);
    }
  }

  function validateMail() {
    if (
      data_doctor.email !== "" &&
      data_doctor.password !== "" &&
      data_doctor.password.length >= 4
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }

  useEffect(() => {
    validateMail();
  }, [data_doctor, password]);

  return (
    <C.Container>
      <C.Header />
      <C.Content>
        <C.Image>
          <img alt="logo centro medico" src={background_logo} />
          <C.Information>Acesso Empresarial</C.Information>
        </C.Image>
        <C.Form>
          <C.Title>Bem vindo! 👋🏻</C.Title>
          <C.Text>
            Por favor preencha seu e-mail e senha de acesso a sua conta.
          </C.Text>
          <C.InputAndLabel>
            <label id="email">Email</label>
            <TextField
              size="small"
              placeholder="johndoe@gmail.com"
              value={data_doctor?.email}
              onChange={(e) =>
                setData_doctor({ ...data_doctor, email: e.target.value })
              }
            />
          </C.InputAndLabel>
          <C.InputAndLabel>
            <div>
              <label>Senha</label>
            </div>
            <TextField
              size="small"
              type="password"
              placeholder="⚉ ⚉ ⚉ ⚉ ⚉ ⚉ ⚉ ⚉"
              value={data_doctor?.password}
              onChange={(e) =>
                setData_doctor({ ...data_doctor, password: e.target.value })
              }
            />
          </C.InputAndLabel>
          <C.ContainerButton>
            <PrimaryButton
              text="Acessar"
              funcao={handleSubmit}
              disabled={disabled}
            />
          </C.ContainerButton>
        </C.Form>
      </C.Content>
    </C.Container>
  );
}
